module.exports = __webpack_public_path__ + "static/media/playfulSong.2460554a.mp3";